const enigmesConfig = {
    trone: {
        enigmesData: require('./e_trone.js').default,
        imageSrc: '/img/jismlnsz.jpg',
    },
    auberge: {
        enigmesData: require('./e_auberge.js').default,
        imageSrc: '/img/jmpnbfcsi.jpg',
    },
    alcove: {
        enigmesData: require('./e_alcove.js').default,
        imageSrc: '/img/jartqifrmp.jpg',
    },
    abri: {
        enigmesData: require('./e_abri.js').default,
        imageSrc: '/img/jhgubwazeq.jpg',
    },
    garnison: {
        enigmesData: require('./e_garnison.js').default,
        imageSrc: '/img/jolhbvfdrmlsw.jpg',
    }/* ,
    enigmesTome2: {
        enigmesData: require('./enigmesTome2.js').default,
        imageSrc: '/img/e-05.jpg',
    } */
};

export default enigmesConfig;
